const ONE_KB = 1024;

export function checkFileSize(file: File, size: number): boolean {
  return file.size / ONE_KB <= size;
}

export function checkFileType(file: File, accept: string): boolean {
  if (!accept) {
    return true;
  }
  const acceptRegExp = new RegExp(
    accept.toLowerCase().split(/[, ]/)
      .filter(e => !!e)
      .map(e => {
        e = e.trim();
        if (e.includes(".")) {
          e = e.replace(".", "\\.") + "$";
        }
        return e.replace(/\*/g, ".\*");
      }).join("|"),
  );
  console.log(acceptRegExp);
  return acceptRegExp.test(file.type) || acceptRegExp.test(file.name.toLowerCase());
}
